'use client';
import styled, { css } from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScBonanzaPromoDashboardContent = styled.div<{
  $isLockedPromo: boolean;
  $isBonusIssued: boolean;
  $isLvl3: boolean;
}>`
  position: relative;
  width: ${({ $isLockedPromo }) => ($isLockedPromo ? 'auto' : '80px')};

  .character {
    position: absolute;
    right: -14px;
    top: -10px;
    ${({ $isLvl3 }) =>
      $isLvl3 &&
      css`
        right: -12px;
      `}
  }

  .characterLocked {
    margin-top: -15px;
    @media (${device.mobile}) {
      display: none;
    }
  }

  .progress-bar-line {
    width: 70px;
    & > .completed  {
      margin-right: ${({ $isBonusIssued }) => ($isBonusIssued ? '3px' : '0')}
    }
  }

  .progress-bar-line > .progress-value {
    ${typography.caption1bold};
  }
`;
